import { render, staticRenderFns } from "./SummaryItemRow.vue?vue&type=template&id=a882af0a&scoped=true&"
import script from "./SummaryItemRow.vue?vue&type=script&lang=js&"
export * from "./SummaryItemRow.vue?vue&type=script&lang=js&"
import style0 from "./SummaryItemRow.vue?vue&type=style&index=0&id=a882af0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a882af0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
